module.exports = __webpack_public_path__ + "img/cba-inversiones-cafe.9a9302ae.png";